// frontend/src/services/networkService.js
import api from '../api';

/**
 * Servicio para la Red Silenciosa (Silent Q-Network)
 */
const networkService = {
  /**
   * Sigue a un usuario por su handle
   */
  follow: async (targetHandle) => {
    return api.post(`/network/follow/${encodeURIComponent(targetHandle)}`);
  },

  /**
   * Deja de seguir a un usuario
   */
  unfollow: async (targetHandle) => {
    return api.delete(`/network/unfollow/${encodeURIComponent(targetHandle)}`);
  },

  /**
   * Busca usuarios públicos
   */
  search: async (query) => {
    return api.get('/network/search', { params: { q: query } });
  },

  /**
   * Obtiene la lista de conexiones (seguidos).
   * Requiere PIN en el header X-Q-PIN-AUTH.
   */
  getConnections: async (pin) => {
    try {
      const response = await api.get('/network/connections', {
        headers: {
          'X-Q-PIN-AUTH': pin
        }
      });
      return response.data;
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        // Lanzamos error específico para que la UI reaccione (ej: sacudir teclado)
        const customError = new Error('PIN_INVALID');
        customError.status = error.response.status;
        throw customError;
      }
      throw error;
    }
  },

  /**
   * Actualiza el perfil de red (handle, visibilidad, PIN)
   */
  updateNetworkProfile: async (data) => {
    return api.patch('/network/profile', data);
  },

  /**
   * Solicita un OTP para cambios de PIN en el perfil de red
   */
  sendPinOtp: async () => {
    return api.post('/network/profile/send-otp');
  },

  /**
   * Obtiene la lista de grupos mentales
   */
  getGroups: async () => {
    return api.get('/network/groups');
  },

  /**
   * Crea un nuevo grupo mental
   */
  createGroup: async (data) => {
    return api.post('/network/groups', data);
  },

  /**
   * Actualiza la membresía (aceptar/abandonar)
   */
  updateGroupMembership: async (groupId, status) => {
    return api.put(`/network/groups/${groupId}/membership`, { status });
  },

  /**
   * Obtiene el historial de chat de un grupo
   */
  getGroupChat: async (groupId) => {
    return api.get(`/network/groups/${groupId}/chat`);
  },

  /**
   * Envía un mensaje al chat de un grupo
   */
  sendGroupMessage: async (groupId, message, lang) => {
    return api.post(`/network/groups/${groupId}/chat`, { message, lang });
  }
};

export default networkService;
